import type { Roles } from '../constants';

export const areUserRolesIn = (userRoles: Roles[], allowedRoles: Roles[]) => {
  return userRoles?.some((role: Roles) => allowedRoles.includes(role));
};
